import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=863dfd98&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=863dfd98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../touch/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863dfd98",
  null
  
)

export default component.exports